import { httpRequest } from "../../http";
import { ValidationResult } from "@models/IngestRun.model";

export class CommandValidateFile {
  async run(fileId: number, ingestDefinitionId: number, populationSegmentName?: string): Promise<ValidationResult> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/${fileId}/validate/`;
    return httpRequest<ValidationResult>(url, {
      method: "POST",
      body: {
        ingest_definition_id: ingestDefinitionId,
        ...(populationSegmentName ? { population_segment_name: populationSegmentName } : {}),
      },
    });
  }
}
